<template>
  <v-card height="100%" class="elevation-3" style="overflow: hidden">
    <v-card-title class="pb-0">
      <h4 class="mb-4 font-weight-regular text-truncate">
        {{ $t("home.cases.attended.title") }}
      </h4>
    </v-card-title>
    <v-divider />
    <v-card-text class="pa-0">
      <v-list class="pt-0">
        <template v-for="(item, i) in items">
          <v-list-item
            :key="i"
          >
            <v-list-item-icon>
              <template v-if="hasTop(i)">
                <v-icon :color="rankingColor(i)">
                  mdi-trophy
                </v-icon>
              </template>
              <template v-else>
                <v-avatar
                  size="30"
                  color="#00cec5"
                >
                  {{ i+1 }}
                </v-avatar>
              </template>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.name" />
            </v-list-item-content>
            <v-list-item-action>
              <v-chip :color="rankingColor(i)">{{ $t("home.cases.attended.caption") }}  {{ item.value }}</v-chip>
            </v-list-item-action>
          </v-list-item>
          <v-divider v-if="i < items.length - 1" :key="`d-${i}`" inset />
        </template>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
const dayjs = require('dayjs')
require('dayjs/locale/es')
dayjs.locale('es')

export default {
  props: {
    isDark: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      series: []
    }
  },

  computed: {
    items () {
      return Array(7).fill({}).map((_, i) => {
        return {
          id: i,
          name: `Lorem ipsum ${i + 1}`,
          value: this.generateNumber()
        }
      })
    }
  },

  mounted () {
  },

  methods: {
    generateNumber (min = 0, max = 100) {
      return Math.floor(Math.random() * (max - min + 1)) + min
    },

    rankingColor (index) {
      let result = '#00cec5'
      if (index === 0) {
        result = '#FFC107'
      } else if (index === 1) {
        result = '#B0BEC5'
      } else if (index === 2) {
        result = '#A1887F'
      }
      return result
    },

    hasTop (index) {
      if (index >= 0 && index <= 2) {
        return true
      }
      return false
    }
  }
}
</script>
